import { useNavigate } from 'react-router-dom'
import * as Global from '../../styles/index'
import * as Txt from '../../styles/text'
import * as S from './styles'
import React, { useState } from 'react'

import { usePostAuthMutation, useGetMeQuery } from '../../services/api'

const AdminLoginCard = () => {
  const navigate = useNavigate()
  const [authenticate] = usePostAuthMutation()
  // const { data: meData } = useGetMeQuery()

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const handleLogin = async () => {
    const loginPayload = {
      username: username,
      password: password
    }

    try {
      const response = await authenticate(loginPayload).unwrap()

      localStorage.setItem('access', response.access)
      localStorage.setItem('refresh', response.refresh)
      // console.log(localStorage.getItem('access'))
      // console.log(localStorage.getItem('refresh'))
      alert('Login realizado com sucesso.')
      navigate('/admin/dashboard')
    } catch (error) {
      alert('Usuário ou senha inválidos, tente novamente.')
    }
  }

  return (
    <>
      <Global.Container>
        <S.LoginCard>
          <S.LogoContainer>
            <S.Logo
              src="https://static-file-vault.vercel.app/cdtchechela/logo_cdtcc.svg"
              alt="Logo da escola"
            />
          </S.LogoContainer>
          <S.TextArea>
            <Txt.TextSm>Acesso restrito à administração do site.</Txt.TextSm>
            <Txt.TextSm>
              Por favor, insira suas credenciais para continuar.
            </Txt.TextSm>
          </S.TextArea>
          <div className="form-floating mb-3">
            <input
              type="text"
              name="user"
              id="userInput"
              className="form-control"
              placeholder=""
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <S.InputLabel htmlFor="user">Nome de usuário</S.InputLabel>
          </div>
          <div className="form-floating mb-3">
            <input
              type="password"
              name="user"
              id="userPassword"
              className="form-control"
              placeholder=""
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <S.InputLabel htmlFor="user">Senha</S.InputLabel>
          </div>
          <S.LoginBtn
            type="button"
            className="btn"
            onClick={() => handleLogin()}
          >
            Entrar
          </S.LoginBtn>
        </S.LoginCard>
      </Global.Container>
    </>
  )
}

export default AdminLoginCard
